import classNames from 'classnames';
import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';

import AnimateReveal from '../AnimateReveal/AnimateReveal';
import Emphasise from '../UI/Emphasise/Emphasise';
import WpImage, { imgSizes } from '../UI/WpImage/WpImage';
import { motion } from '../UI/framer-motion-custom';
import mipLogo from '../../assets/images/mip-logo.png';
import * as styles from './Cover.module.scss';

export const coverThemes = {
  NAVY: 'themeNavy',
  TAN: 'themeTan',
  PLUM: 'themePlum',
};

const Cover = React.forwardRef(
  (
    {
      as: Comp = 'header',
      children,
      image,
      theme = coverThemes.TAN,
      useSecondaryImage,
      hasHeaderOffset = true,
      hasSpacer = false,
      isCompact = false,
      reveal = true,
    },
    ref
  ) => {
    const className = classNames(styles.cover, {
      [ styles.noImage ]: !image,
      [ styles.hasImage ]: !!image,
      [ styles[ theme ] ]: !image || useSecondaryImage,
      [ styles.secondaryImage ]: useSecondaryImage,
      [ styles.hasSpacer ]: hasSpacer,
      [ styles.hasHeaderOffset ]: hasHeaderOffset,
      [ styles.isCompact ]: isCompact,
    });

    return (
      <Comp className={className} ref={ref}>
        <div className={styles.inner}>
          {reveal ? (
            <AnimateReveal
              staggerChildren={true}
              at="0px"
            >
              {children}
            </AnimateReveal>
          ) : (
            children
          )}
        </div>

        {image?.localFile && (
          <GatsbyImage
            image={image.localFile?.childImageSharp?.gatsbyImageData}
            className={styles.image} />
        )}

        {!image?.localFile && image?.mediaDetails && (
          <WpImage className={styles.image} {...image} size={imgSizes.XLARGE} />
        )}
      </Comp>
    );
  }
);

export default Cover;

export const CoverCategory = ({ children, ...other }) => (
  <motion.h1 className={styles.category} {...other}>
    {children}
  </motion.h1>
);

export const CoverHeading = ({
  as: Comp = motion.h1,
  children,
  isSecondary = false,
  control,
  ...other
}) =>
  control ? (
    <motion.div className={styles.headingWrap}>
      <Comp
        className={isSecondary ? styles.headingSecondary : styles.heading}
        {...other}
      >
        <Emphasise>{children}</Emphasise>
      </Comp>
      <div className={styles.headingControl}>{control}</div>
    </motion.div>
  ) : (
    <Comp
      className={isSecondary ? styles.headingSecondary : styles.heading}
      {...other}
    >
      <Emphasise>{children}</Emphasise>
    </Comp>
  );

export const CoverLead = ({ children, isPrimary, ...other }) =>
  isPrimary ? (
    <motion.p className={styles.leadPrimary} {...other}>
      <Emphasise>{children}</Emphasise>
    </motion.p>
  ) : (
    <motion.p className={styles.lead} {...other}>
      {children}
    </motion.p>
  );

export const CoverPrice = ({ children, ...other }) => (
  <motion.p className={styles.price} {...other}>
    From <strong>{children}</strong>
  </motion.p>
);


export const CoverMip = ({ ...other }) => (
  <motion.p className={styles.mip}  {...other}>In association with <br /><img alt="" src={mipLogo}/></motion.p>
);
